import React from 'react';
import styles from './ContentLoader.module.css'

const ContentLoader = () => {
  return (
      <div className={styles.loadingOverlay}>
        <div className={styles.loadingSpinner}></div>
        <p>Loading...</p>
      </div>
  );
};

export default ContentLoader;
